'use client'

import CalendarIcon from '@/components/icons/calendar-icon'
import ChevronDown from '@/components/icons/chevron-down'
import ClockIcon from '@/components/icons/clock-icon'
import DurationIcon from '@/components/icons/duration-icon'
import { localDateTime } from '@/helpers/datetime'
import { cn } from '@/lib/utils'
import { timeOfDayOptions, weatherOptions } from '@/resources/session-options'
import { useState } from 'react'

export default function ViewSessions({ event }) {
  const [sessionsTabOpen, setSessionsTabOpen] = useState(false)

  function handleSessionBtn() {
    if (event == null || typeof event == 'undefined') {
    } else {
      setSessionsTabOpen(!sessionsTabOpen)
    }
  }

  return (
    <div className="col-span-2 mb-[18px] mt-4 flex flex-col justify-center rounded-sm border border-neutral-blue-700 bg-neutral-blue-900 bg-opacity-30">
      <button
        className="pointer-events-auto flex w-full justify-center self-center py-[18px]"
        onClick={handleSessionBtn}
      >
        <div className="self-center">View Sessions </div>
        <ChevronDown
          className={cn(
            'stroke-3 ml-[8px] h-4 w-4 self-center stroke-shades-0 transition-transform duration-300',
            sessionsTabOpen ? 'rotate-180' : 'rotate-0',
          )}
        />
      </button>

      <div className={cn(sessionsTabOpen ? ' ' : 'hidden')}>
        <div className="mb-[8px] flex flex-col">
          {event.sessions?.map((session, key) => {
            const dayJsDate = localDateTime({
              datetime: session.targetDateTime,
              format: false,
            })

            return (
              <div
                className="mx-[16px] my-[8px] flex flex-col justify-between rounded-sm border border-neutral-blue-700 bg-neutral-blue-800 px-[8px] py-[16px] md:flex-row"
                key={key}
              >
                <div className="ml-[8px] flex flex-col self-auto md:flex-row md:self-center">
                  <div className="mx-[8px] ml-0 flex self-auto align-middle text-[20px] md:ml-[8px] md:self-center">
                    {session.name}
                  </div>
                  {session.type === 'practice' ? (
                    <div className="flex self-auto align-middle text-neutral-blue-500 md:self-center">
                      Practice Session
                    </div>
                  ) : session.type === 'qualifying' ? (
                    <div className="flex self-auto align-middle text-neutral-blue-500 md:self-center">
                      Qualifying Session
                    </div>
                  ) : session.type === 'race' ? (
                    <div className="flex self-auto align-middle text-neutral-blue-500 md:self-center">
                      Race Session
                    </div>
                  ) : null}
                </div>
                <div className="ml-[8px] mr-[8px] mt-[10px] flex flex-wrap self-auto text-[14px] md:ml-0 md:mt-0 md:self-center">
                  <div className="mr-2 flex items-center">
                    <CalendarIcon className="ml-0 h-4 w-4 stroke-shades-0 md:ml-[8px] desktop-sm:h-6 desktop-sm:w-6" />
                    <p className="mx-[8px] w-[80px] text-center font-semibold">
                      {dayJsDate.format('ddd DD MMM')}
                    </p>
                  </div>

                  <div className="mr-2 flex items-center">
                    <ClockIcon className="h-4 w-4 stroke-shades-0 desktop-sm:h-6 desktop-sm:w-6" />
                    <p className="mx-[8px] w-[35px] text-center font-semibold">
                      {dayJsDate.format('HH:mm')}
                    </p>
                  </div>

                  <div className="flex w-fit items-center lg:w-[85px]">
                    <DurationIcon className="ml-0 h-4 w-4 stroke-shades-0 stroke-[1.5px] lg:ml-[8px] desktop-sm:h-6 desktop-sm:w-6" />
                    <p className="mx-[8px] flex w-fit text-center font-semibold lg:w-[35px]">
                      <span className="mr-[5px]">{session.duration}</span>
                      <span className="">{session.durationType}</span>
                    </p>
                  </div>

                  {session.timeOfDay ? (
                    <div className="ml-0 flex w-[80px] items-center md:ml-[8px]">
                      <div className="mx-[8px] ml-0 h-6 w-6 stroke-shades-0 md:ml-[8px]">
                        {
                          timeOfDayOptions.find(
                            (tod) => tod.name === session.timeOfDay,
                          )?.icon
                        }
                      </div>
                      <div className="mx-[8px] ml-[3px]">
                        {session.timeOfDay.charAt(0).toUpperCase() +
                          session.timeOfDay.slice(1)}
                      </div>
                    </div>
                  ) : null}

                  {session.weather ? (
                    <div className="ml-0 flex w-[100px] items-center md:ml-[8px]">
                      <div className="mx-[8px] ml-0 h-6 w-6 stroke-shades-0 md:ml-[8px]">
                        {
                          weatherOptions.find(
                            (weather) => weather.name === session.weather,
                          )?.icon
                        }
                      </div>
                      <div className="mx-[8px] ml-[3px]">
                        {session.weather.charAt(0).toUpperCase() +
                          session.weather.slice(1)}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
